export const SET_SERVER = 'SET_SERVER';
